import Link from 'gatsby-link';
import React, { Component } from 'react';
import { Button, Container, Image, Menu, Sidebar } from 'semantic-ui-react';

export default class MobileSubpageSideBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuOpen: false,
            menuForceClose: true
        }
    }

    handleItemClick = (e, { name }) => this.setState({ activeItem: name })

    // handleMenuClose=()=>{
    //     this.props.menuOpen(false)
    // }

    handleMenuOpen = () => {
        let state = !this.state.menuOpen
        this.setState({ menuOpen:  state, menuForceClose: state})
        this.props.menuOpen(state)
        
    }

    render() {
        const { activeItem, menuForceClose } = this.state
        return (
            <Sidebar.Pushable>
                <Sidebar
                    animation='overlay'
                    direction='right'
                    visible={this.props.visible}                
                >
                    <div className="mpost-mobile--menu">
                        <Menu secondary className="mpost-mobile--menu--topbar">
                            <Menu.Item
                                as={Link}
                                to="/"
                                className="mpost-brand--menu mobile"
                            >
                                <Image src={require('../assets/img/logo-brand.svg')} size="tiny" />
                            </Menu.Item>
                            <Menu.Menu position="right">
                                <Button basic icon="x" className="mpost-mobile--menu--close" onClick={this.handleMenuOpen} />
                            </Menu.Menu>
                        </Menu>
                        <Menu vertical fluid className="mpost-mobile--menu--items">
                            <Menu.Item as={Link} to="/" className="mpost-mobile--menu--item" name='mobile_home' active={activeItem === 'mobile_home'} onClick={this.handleItemClick}>
                                HOME
                        </Menu.Item>
                            <Menu.Item as={Link} to="/work/" className="mpost-mobile--menu--item" name='mobile_home' active={activeItem === 'mobile_home'} onClick={this.handleItemClick}>
                                WORK
                        </Menu.Item>
                            <Menu.Item as={Link} to="/services/" className="mpost-mobile--menu--item" name='mobile_home' active={activeItem === 'mobile_home'} onClick={this.handleItemClick}>
                                SERVICES
                        </Menu.Item>
                            <Menu.Item as={Link} to="/contact/" className="mpost-mobile--menu--item" name='mobile_home' active={activeItem === 'mobile_home'} onClick={this.handleItemClick}>
                                CONTACT US
                        </Menu.Item>
                        </Menu>
                        <Container className="mpost-mobile-menu--footer" textAlign="center">
                            <Image centered style={{ margin: '20px auto', opacity: 0.5 }} src={require('../assets/img/logo-gray.svg')} size="tiny" />
                            <p className="mpost-copyright--text">&copy; 2018 MAYAD POST PRODUCTIONS. ALL RIGHTS RESERVED</p>
                        </Container>
                    </div>
                </Sidebar>
                <Sidebar.Pusher>
                    {this.props.children}
                </Sidebar.Pusher>
            </Sidebar.Pushable>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/MobileSubpageSideBar.js